<script>
  import { onMount } from "svelte";
  import {
    addHash,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";

  let { http, toastr, auth, search, openModal } = $props();

  let users = $state([]);
  let searchText = $state("");
  let sortType = $state(loadPersisted("users", "sortType", "login"));
  let sortReverse = $state(loadPersisted("users", "sortReverse", true));
  let currentPage = $state(1);
  const itemsPerPage = 11;

  $effect(() => {
    savePersisted("users", "sortType", sortType);
    savePersisted("users", "sortReverse", sortReverse);
  });

  onMount(() => {
    http.get("/api/uzytkownik.php").then(
      (response) => {
        if (response.data.status == 200) {
          users = addHash(response.data.records, "idau");
        } else {
          toastr.error("Błąd: " + response.data.message);
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  let filteredUsers = $derived(search(users, searchText));
  let sortedUsers = $derived(localeOrderBy(filteredUsers, sortType, sortReverse));
  let totalItems = $derived(filteredUsers.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedUsers = $derived(slice(sortedUsers, itemsPerPage, currentPage));

  $effect(() => {
    searchText;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }

  function editUser(user) {
    openModal("UserEditModal", { user }).then(
      (editedItem) => {
        if (!editedItem) return;
        if (editedItem.hasOwnProperty("idau")) {
          http.put("/api/uzytkownik.php", editedItem).then(
            (response) => {
              if (response.data.status == 200) {
                toastr.info("Edycja zakończona sukcesem");
                Object.assign(user, editedItem);
              } else {
                toastr.error("Błąd: " + response.data.message);
              }
            },
            () => {
              toastr.error("Błąd połączenia");
            },
          );
        } else {
          http.post("/api/uzytkownik.php", editedItem).then(
            (response) => {
              if (response.data.status == 200) {
                const inserted = response.data.records[0];
                users = [...users, inserted];
                toastr.info(
                  "Utworzono nowego użytkownika " +
                    inserted.login +
                    " dla " +
                    inserted.nazwa,
                );
              } else {
                toastr.error("Błąd: " + response.data.message);
              }
            },
            () => {
              toastr.error("Błąd połączenia");
            },
          );
        }
      },
      () => {},
    );
  }

  function setPasswd(user) {
    openModal("UserSetPasswordModal", { user }).then(
      (record) => {
        if (!record) return;
        http.put("/api/ustaw-haslo.php", record).then(
          (response) => {
            if (response.data.status == 200) {
              toastr.info("Hasło zostało ustawione");
            } else {
              toastr.error("Błąd: " + response.data.message);
            }
          },
          () => {
            toastr.error("Błąd połączenia");
          },
        );
      },
      () => {},
    );
  }

  function deleteUser(user) {
    if (user.login == auth.getLoggedUser().login) {
      toastr.error("Nie możesz skasować samego siebie!");
      return;
    }
    if (confirm("Skasować uzytkownika o loginie " + user.login + "?")) {
      http.delete("/api/uzytkownik.php?id=" + user.idau).then(
        (response) => {
          if (response.data.status == 200) {
            users = users.filter((u) => u.idau != user.idau);
            toastr.info(
              "Skasowano użytkownika " + user.login + " dla " + user.nazwa,
            );
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    }
  }
</script>

<h3><i class="fas fa-user-circle fa-lg"></i>&nbsp;&nbsp;Użytkownicy serwisu
<div class="btn-toolbar pull-right">
<button class="btn btn-primary btn-sm pull-right" onclick={() => editUser({})} title="Dodaj nową akcję...">
    <i class="fa fa-plus" aria-hidden="true"></i>
    <span class="hidden-xs">&nbsp;Dodaj nowego użytkownika...</span></button>
</div>
</h3>
<div class="clearfix"></div>
<div class="text-left"><small><i class="fa fa-random" aria-hidden="true"></i>
W tej chwili mamy {users.length} zdefiniowanych użytkowników, {filteredUsers.length} przefiltrowanych poniżej.
</small><p></p></div>

<form>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon"><i class="fas fa-search"></i></div>
        <input type="text" class="form-control input-sm" placeholder="Wyszukaj użytkownika" bind:value={searchText}>
      </div>
    </div>
</form>

<table class="table table-condensed table-hover table-striped">

    <thead class="thead-default">
      <tr>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("idau"); }}>
          Lp
          {#if sortType == "idau" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "idau" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("login"); }}>
          Login
          {#if sortType == "login" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "login" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nazwa"); }}>
          Imie i nazwisko
          {#if sortType == "nazwa" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nazwa" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("ost_login"); }}>
          Ostatnie udane logowanie
          {#if sortType == "ost_login" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "ost_login" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nieudane"); }}>
          Liczba nieudanych logowań
          {#if sortType == "nieudane" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nieudane" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("blokada"); }}>
          Blokada
          {#if sortType == "blokada" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "blokada" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("rola"); }}>
          Rola
          {#if sortType == "rola" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "rola" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
            Operacje
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedUsers as user (user.idau)}
      <tr class={user.blokada ? "danger" : ""}>
        <td>
        {user.idau}
        </td>
        <td>
        {user.login}
        </td>
        <td class="hidden-xs">
        {user.nazwa}
        </td>
        <td class="hidden-xs">
        {user.ost_login}
        </td>
        <td class="hidden-xs">
        {user.nieudane}
        </td>
        <td>
        {user.blokada == 0 ? "Nie" : "Tak"}
        </td>
        <td class="hidden-xs">
        {user.rola}
        </td>
        <td>
        <a href="#" onclick={(e) => { e.preventDefault(); editUser(user); }}>Edytuj</a> | <a href="#" onclick={(e) => { e.preventDefault(); setPasswd(user); }}>Ustaw hasło</a> | <a href="#" onclick={(e) => { e.preventDefault(); deleteUser(user); }}>Skasuj</a>
        </td>
      </tr>
      {/each}
    </tbody>

</table>

<ul class="pagination pagination-sm">
  <li class:disabled={currentPage === 1}><a href="#" onclick={(e) => { e.preventDefault(); currentPage = 1; }}>Pierwsza</a></li>
  <li class:disabled={currentPage === 1}><a href="#" onclick={(e) => { e.preventDefault(); currentPage = Math.max(1, currentPage - 1); }}>Poprzednia</a></li>
  {#each Array.from({ length: numPages }, (_, i) => i + 1) as page}
  <li class:active={page === currentPage}><a href="#" onclick={(e) => { e.preventDefault(); currentPage = page; }}>{page}</a></li>
  {/each}
  <li class:disabled={currentPage === numPages}><a href="#" onclick={(e) => { e.preventDefault(); currentPage = Math.min(numPages, currentPage + 1); }}>Następna</a></li>
  <li class:disabled={currentPage === numPages}><a href="#" onclick={(e) => { e.preventDefault(); currentPage = numPages; }}>Ostatnia</a></li>
</ul>
